import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-section" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = { class: "col-12 col-md-10 col-lg-9 text-center" }
const _hoisted_5 = {
  key: 0,
  class: "text-section__btn text-center"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("b", null, "Jetzt CAS", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("b", null, "werden", -1)
const _hoisted_8 = {
  key: 0,
  class: "co2-badge",
  ref: "badge"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SectionSpacerClouds = _resolveComponent("SectionSpacerClouds")!
  const _component_SectionSpacerBar = _resolveComponent("SectionSpacerBar")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["text-section__container", _ctx.containerClasses])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ]),
        (_ctx.showKlimaheldButton && _ctx.hasKlimaheldSection)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scrollToKlimaheld && _ctx.scrollToKlimaheld(...args)))
              }, [
                _hoisted_6,
                _createTextVNode("Klimaheld "),
                _hoisted_7
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.showBadge !== 'false')
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, null, 512))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.spacer === 'clouds')
      ? (_openBlock(), _createBlock(_component_SectionSpacerClouds, {
          key: 0,
          placement: _ctx.spacerCloudsPlacement
        }, null, 8, ["placement"]))
      : _createCommentVNode("", true),
    (_ctx.spacer === 'bar')
      ? (_openBlock(), _createBlock(_component_SectionSpacerBar, {
          key: 1,
          align: _ctx.spacerBarAlign
        }, null, 8, ["align"]))
      : _createCommentVNode("", true)
  ]))
}